if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.formData;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
      // add the custom properties
			this.formData = serializeForm(this.form)
			this.editFormProperties(this.formData)
			// If form has message, add quantity is more than 1
			if (this.formData.properties.message && this.formData.quantity > 1) {
        let sentForm = this.formData
				let messageProductResponse = this.addProductWithMessage(sentForm)
				if (messageProductResponse.status) {
          this.handleErrorMessage(response.description)
					return
				}
				this.formData.quantity = this.quantity.value - 1
				delete this.formData.properties.message
				delete this.formData.properties.message_body
			}

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // delete config.headers['Content-Type'];

      // const formData = new FormData(this.form);
      // if (this.dataset.cartType != 'page') {
      //   formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      //   formData.append('sections_url', window.location.pathname);
      //   this.cart.setActiveElement(document.activeElement);
      // }
      // config.body = formData;
      
      config.body = JSON.stringify({
        ...JSON.parse(JSON.stringify(this.formData)),
        sections: this.cart.getSectionsToRender().map(section => section.id),
        sections_url: window.location.pathname,
      })
      if (this.dataset.cartType != 'page') {
        this.cart.setActiveElement(document.activeElement);
      }
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          
          const cartGwp = document.querySelector('gwp-container')

					// If form has giftbox, add giftbox to the cart
					if (this.formData.properties._gift_box) {
						this.addGiftbox(this.formData.quantity)
						return
					} 
					if (cartGwp) {
						this.giftWithPurchaseProduct()
						return
					}
					
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.dataset.cartType == 'page') {
              window.location = window.routes.cart_url;
              return;
            } else {
              this.cart.renderContents(response);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    editFormProperties(formData) {
      const checkbox = document.querySelector('checkbox-input')?.input
      const quantity = document.querySelector('quantity-input').input
      const message_textarea = document.querySelector('textarea')

      delete formData.complimentary
      delete formData.message

      if (formData['quantity'] !== quantity.value) {
        this.formData['quantity'] = quantity.value
      }
      // set item properties to object to add to
      if (formData['properties'] === undefined)
        this.formData['properties'] = {}
      
      // set item tags to properties
      if (formData['tags']) {
        const cleanedTags = formData['tags']
          .split('::')
          .join(', ')
        this.formData.properties['_tags'] = cleanedTags
        delete formData.tags
      }
      
      // adding comp_box to properties
      if (
        checkbox &&
        checkbox.checked &&
        checkbox.name === 'complimentary'
      ) {
        this.formData.properties['_complimentary_box'] = true
      }

      // adding giftbox to properties
      if (
        checkbox &&
        checkbox.name === 'giftbox' &&
        checkbox.checked
      ) {
        this.formData.properties['_gift_box'] = true
      }

      if (
        message_textarea?.value
      ) {
        this.formData.properties['_has_message'] = true
        // adding custom messaging to properties
        if (
          message_textarea.value &&
          message_textarea.value.length > 0
        ) {
          this.formData.properties['_message'] =
            message_textarea.value
        }
      }
      return
    }
    giftWithPurchaseProduct() {
      let gwp = document.querySelector('gwp-container')
      let gwp_id = gwp.dataset.gwpid
      let total = gwp.dataset.collection_total
      let threshold = gwp.dataset.gwp_threshold
      let action = gwp.dataset.action
      let itemInCart = gwp.dataset.itemincart
      let line_id = gwp.dataset.line

      if (
        parseInt(total) >= parseInt(threshold) &&
        action === 'add'
      ) {
        if (!itemInCart && !line_id) {
          const formData = {
            form_type: 'product',
            id: gwp_id,
            quantity: '1',
            properties: {
              _GWP: true,
            },
          }
          const config = fetchConfig('javascript')
          config.headers['X-Requested-With'] = 'XMLHttpRequest'

          config.body = JSON.stringify({
            ...JSON.parse(JSON.stringify(formData)),
            sections: this.cart
              .getSectionsToRender()
              .map(section => section.id),
            sections_url: window.location.pathname,
          })

          fetch(`${routes.cart_add_url}`, config)
            .then(response => {
              return response.json()
            })
            .then(response => {
              if (response.status) {
                this.handleErrorMessage(
                  response.description
                )
                return
              }

              this.cartNotification.renderContents(response)
            })
            .catch(e => {
              console.error(e)
            })
            .finally(() => {
            });
        }
      }
    }
    addGiftbox(quantity) {
      const formData = {
        form_type: 'product',
        id: '32080824402005',
        quantity: quantity,
        properties: {
          _is_gift_box: true,
        },
      }
      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
    
      config.body = JSON.stringify({
        ...JSON.parse(JSON.stringify(formData)),
      })
    
      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description)
            return;
          }
          window.location.href = '/cart'
        })
        .catch(error => {
          console.error(error)
        })
    }
    addProductWithMessage(formData) {
      let productRes = null
      const cleanForm = formData
    
      cleanForm.quantity = 1
    
      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
    
      config.body = JSON.stringify({
        ...JSON.parse(JSON.stringify(cleanForm)),
      })
    
      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            // console.log(response.description)
            return
          }
    
          // If form has giftbox, add giftbox to the cart
          if (formData.properties._gift_box) {
            let giftboxResponse = this.addGiftbox(formData.quantity)
            if (giftboxResponse.status) {
              this.handleErrorMessage(response.description)
              return
            }
          }
          return
        })
        .catch(error => {
          console.error(error)
        })
    
      return productRes
    }
  });
}
